// extracted by mini-css-extract-plugin
export default {"container":"FooterLayout_container__owasA"};